import { createApiFactory, createPlugin, createRoutableExtension, discoveryApiRef } from '@backstage/core-plugin-api';
import { apfApiRef, ApfClient } from './api/client';

import { rootRouteRef } from './routes';

export const apfPlugin = createPlugin({
  id: 'apf',
  apis: [
    createApiFactory({
      api: apfApiRef,
      deps: { discoveryApi: discoveryApiRef },
      factory: ({discoveryApi}) => new ApfClient(discoveryApi)
    })
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const ApfPage = apfPlugin.provide(
  createRoutableExtension({
    name: 'ApfPage',
    component: () =>
      import('./components/MainPage').then(m => m.MainPage),
    mountPoint: rootRouteRef,
  }),
);
